import { Notation } from './notation';

export interface CompanyFinChartData {
  text: string;
  color: string;
  value_type: string;
  chart_type: number;
  value: [number];
  value_original: number;
}

export interface CompanyFinChart {
  x_axis: [string];
  chart_data: [CompanyFinChartData];
}

export interface CompanyDailyChartPrice {
  date: number | Date;
  formated_date: string;
  xlabel: number | Date;
  value: string;
}

export interface CompanyDailyChart {
  prices: Array<CompanyDailyChartPrice>;
  timeframe: string;
  xaxisopt: string;
  markingpoint: string;
  change: number;
  percentage: string;
  cagr: string;
  drawdown: string;
}

export interface CompanySentiment {
  start_value: number;
  end_value: number;
  value: number;
  periode: string;
}

export interface CompanyOrderbook {
  bid: {
    price: string;
    volume: string;
  };
  offer: {
    price: string;
    volume: string;
  };
}

export interface CompanyLastPrice {
  name: string;
  type: string;
  symbol: string;
  previous: string;
  price: string;
  time: string;
  percentage: number;
  change: string;
  aum: string;
  date: string;
  prices: [string];
  orderbook: CompanyOrderbook;
  notation: [Notation];
  uma: boolean;
  tradeable: number;
  symbol_2: string;
  symbol_3: string;
  country: string;
  exchange: string;
  status: number;
  tabs: string;
  indexes: string;
}

export interface Company {
  id: string;
  name: string;
  type: string;
  symbol: string;
  created: string | Date;
  updated: string | Date;
  value: string;
  previous: string;
  price: string;
  time: string;
  percentage: number;
  change: string;
  volume: number;
  average: string;
  aum: string;
  date: string;
  followers: number;
  followed: number;
  sector: string;
  sub_sector: string;
  prices: [string];
  orderbook: CompanyOrderbook;
  notation: [Notation];
  uma: boolean;
  tradeable: number;
  symbol_2: string;
  symbol_3: string;
  country: string;
  exchange: string;
  status: number;
  tabs: [string];
  indexes: [string];
  sentiment: CompanySentiment;
  official: number;
  desc: string;
  img: string;
  other: string;
  url: string;
  total_followers: number;
}

export interface CompanyTrending {
  change: string;
  symbol: string;
  percent: string;
  name: string;
  last: string;
  previous: string;
  symbol_2: string;
  symbol_3: string;
  company_id: string;
  notation: Array<any>;
  uma: boolean;
  tradeable: number;
  country: string;
  type: string;
  corp_action: {
    active: boolean;
    icon: string;
    text: string;
  };
  isexist: number;
  status: string;
  icon_url: string;
  is_following: boolean;
  formatted_price: string;
  is_exists: boolean;
  prices?: number[];
}

export interface CompanyPriceFeedClose {
  prices: string[];
  symbol: string;
}

export interface CompanyHotList {
  companyid: string;
  country: string;
  type: string;
  symbol: string;
  symbol_2: string;
  symbol_3: string;
  name: string;
  tradeable: number;
  last: string;
  change: string;
  percent: string;
  followed: number;
  volume: number;
  isexist: number;
  notation: [Notation];
  uma: boolean;
}

export interface CompanyPopular {
  companyid: string;
  followed: number;
  isexist: number;
  symbol: string;
  symbol_2: string;
  symbol_3: string;
  name: string;
}

export interface CompanyProfileSecretary {
  id: string;
  key: string;
  value: string;
  lastupdate: string | Date;
}

export interface CompanyProfileAdresses {
  id: string;
  key: string;
  lastupdate: string | Date;
  value: string;
  json: {
    Phone: string;
    Fax: string;
    NPWP: string;
    Email: [string];
    Website: string;
  };
}

export interface CompanyKeyExecutiveItem {
  id: string;
  key: string;
  value: string;
  lastupdate: string | Date;
}

export interface CompanyKeyExecutive {
  commissioner: Array<CompanyKeyExecutiveItem>;
  director: Array<CompanyKeyExecutiveItem>;
  independent_commissioner: Array<CompanyKeyExecutiveItem>;
  president_commissioner: Array<CompanyKeyExecutiveItem>;
  president_director: Array<CompanyKeyExecutiveItem>;
  vice_president: Array<CompanyKeyExecutiveItem>;
  vice_president_commissioner: Array<CompanyKeyExecutiveItem>;
  independent_vice_president_commissioner: Array<CompanyKeyExecutiveItem>;
  independent_president_commissioner: Array<CompanyKeyExecutiveItem>;
}

export interface CompanyHistory {
  date: string | Date;
  price: string;
  shares: string;
  amount: string;
  board: string;
  registar: string;
  underwriters: [any];
}

export interface CompanyProfile {
  subsidiary: string;
  shareholder: string;
  key_executive: CompanyKeyExecutive;
  address: CompanyProfileAdresses;
  secretary: [CompanyProfileSecretary];
  background: string;
  history: CompanyHistory;
}

export interface CompanyInfo {
  aum: string;
  average: string;
  change: string;
  country: string;
  created: string;
  date: string;
  exchange: string;
  followed: number;
  followers: number;
  id: string;
  indexes: string[];
  name: string;
  orderbook: {
    bid: {
      price: string;
      volume: string;
    };
    offer: {
      price: string;
      volume: string;
    };
  };
  percentage: number;
  previous: string;
  price: string;
  prices: string[];
  sector: string;
  sentiment: {
    end_value: number;
    period: string;
    start_value: number;
    value: number;
  };
  status: string;
  sub_sector: string;
  symbol: string;
  symbol_2: string;
  symbol_3: string;
  tabs: string[];
  time: string;
  tradeable: number;
  type_company: string;
  updated: string;
  value: string;
  volume: string;
  market_hour: {
    status: string;
    time_left: number;
    formatted_time_left: string;
    suspend_info: string;
  };
  is_holding_exist: boolean;
  formatted_price: string;
  is_price_alert_exist: boolean;
  notation: Notation[];
  trade_type: string;
  catalogs: {
    company_symbol: string;
    catalog_name: string;
    id: string;
    parent: string;
    company_type: string;
  }[];
  indexes_data: {
    company_symbol: string;
    company_type: string;
  }[];
  icon_url: string;
  corp_action: {
    active: boolean;
    icon: string;
    text: string;
  };
  uma: boolean;
  day_trade_info: {
    is_show_multiplier: boolean;
    multiplier: string;
  };
  day_tarde_multiplier: string;
  trading_limit_info: {
    haircut_percentage: string;
    is_trading_limit: boolean;
  };
}

export interface CompanyCategories {
  type: string;
  name: string;
}

export interface CompanySuggestions {
  id: string;
  name: string;
  type: string;
  symbol: string;
  created: string | date;
  updated: string | date;
  followers: number;
  followed: number;
  suggsted_type: string;
  symbol_2: string;
  symbol_3: string;
  country: string;
  exchange: string;
  status: number;
}

export interface FinancialItem {
  itemid: number;
  itemname: string;
  results: Record<string, string>;
}

// Company key stat
interface FinancialItemResult {
  fitem_id: string;
  fitem_name: string;
  fitem_value: string;
  hidden_graph_ico: boolean;
}

interface ClosureFinancialItemResult {
  fin_name_results: Array<FinancialItemResult>;
  keystats_name: string;
}

interface RecentQuarter {
  date: string;
  quarter: string;
  stats: {
    current_shareoutstanding: string;
    market_cap: string;
  };
  is_new_update: boolean;
}

interface PeriodValues {
  period: string;
  quarter_value: string;
  year: string;
  is_new_update: boolean;
}

interface FinancialYearValues {
  year: string;
  period_values: Array<PeriodValues>;
  annualised_value: string;
  ttm_value: string;
  is_new_update: boolean;
  dividend: string;
  payout_ratio: string;
  dividend_yield: string;
}

export interface FinancialYearGroups {
  most_recent_quarter: any;
  financial_year_values: Array<FinancialYearValues>;
  fitem_name: string;
}

export interface CompanyKeystats {
  closure_fin_items_results: Array<ClosureFinancialItemResult>;
  financial_year_parent: {
    financial_year_groups: Array<FinancialYearGroups>;
  };
  most_recent_quarter: RecentQuarter;
}

export interface PriceTarget {
  best_target: number;
  best_low_target: number;
  best_high_target: number;
  current_price: number;
}

export interface AnalystRating {
  recommendation: string;
  price_target?: PriceTarget;
  total_buy: number;
  total_sell: number;
  total_hold: number;
  total_analyst: number;
  symbol?: string;
  last_updated: string;
}
// Company financials
export interface CompanyFinancial {
  currency: Array<string>;
  defaultCurrency: string;
  htmlReport: string;
  rounding_value: Record<string, number>;
}

export interface CompanySubsidiaries {
  company_name: string;
  business_type: string;
  location: string;
  commercial_year: string;
  total_assets: string;
  percentage: string;
}

export interface CompanySubsidiary {
  subsidiaries: Array<CompanySubsidiaries>;
  currency: string;
  last_updated_period: string;
}

export interface IClevertapEvent {
  tabPath: string;
  timeout: number;
  isFromChart?: boolean;
}

export interface IClevertapEventReturn {
  eventName: string;
  eventPayload: any;
}

export enum CompanyActionEnums {
  STREAM = 'stream',
  NEWS = 'news',
  KEYSTATS = 'keystats',
  FINANCIALS = 'financials',
  FUNDACHART = 'fundachart',
  CHARTBIT = 'chartbit',
  COMPARISON = 'comparison',
  INSIDER = 'insider',
  PROFILE = 'profile',
  CORPACTION = 'corp_action',
  SEASONALITY = 'seasonality',
  ANALYST = 'analysis',
}

// Navbar interface
export enum TabListNameEnums {
  HOME = '',
  STREAM = 'stream',
  NEWS = 'news',
  KEYSTATS = 'keystats',
  ANALYST = 'analyst',
  FINANCIALS = 'financials',
  FUNDACHART = 'fundachart',
  SEASONALITY = 'seasonality',
  CHARTBIT = 'chartbit',
  COMPARISON = 'comparison',
  INSIDER = 'insider',
  PROFILE = 'profile',
  CORP_ACTION = 'corp.action',
  CONSENSUS = 'EPS Estimate',

  CORP_ACTION_NEW_NAME = 'corpaction',

  BUY = 'buy',
}

export interface ITabItems {
  label: string;
  path: string;
  isNewFeature?: boolean;
}

export interface ITabList {
  [keys: string]: ITabItems;
}

export interface CompanyFRFinItem {
  annual_coupon_rate: string;
  due_date: string;
  minimum_order: string;
  next_coupon_date: string;
  coupon_distribution: string;
  issued_date: string;
  bid_price: string;
  offer_price: string;
  performance: string;
  yield: string;
}

export interface CompanyFRFinData {
  fr_fitem: CompanyFRFinItem;
}
